import React from 'react'
import PropTypes from 'prop-types'
import { AppliedTooltip as Tooltip, PopoverContainer, BaseSpan } from '../AppliedTooltip/AppliedTooltip'

const popoverTop = (
    <PopoverContainer title="Hard Requirements" color="#F0C222">
        Too many mandated requirements make the job unappealing to candidates
        (especially women) - make sure each of these is actually a MUST
    </PopoverContainer>
)

class MustSpan extends React.Component {
    render() {
        return (
            <span>
                <Tooltip
                    popoverContent={popoverTop}
                    disabled={!this.props.user.userId}
                >
                    <BaseSpan
                        offsetKey={this.props.offsetKey}
                        disabled={!this.props.user.userId}
                        color="#FFED48"
                        borderColor="#F0C222"
                    >
                        {this.props.children}
                    </BaseSpan>
                </Tooltip>
            </span>
        )
    }
}

MustSpan.propTypes = {
    children: PropTypes.array,
}

export default MustSpan
